<!-- sqm-出厂报告模板-详情 -->
<template>
  <div class="shipmentReport">
    <div class="tabbar">
      <left theme="filled" style="font-size: 20px; margin: 6px 16px 0 24px; float: left" @click="$router.back()" />
      <div class="add_title">{{ h_i18n('515ddeee81af7132f758a3c4a18f1cef') }}</div>
      <div class="btn_gro">
        <span style="margin-right: 10px;" @click="ceshi">{{ detailQueryList.versionNo || '' }}</span>
        <!-- <div class="item_btn" style="width: 88px" @click="synchronizeData()">
          历史版本
        </div> -->
        <div class="item_btn" @click="$router.back()">{{ h_i18n('5f411223ca5a01a5adf20fe735a433d0') }}</div>
        <!-- <div class="item_btn" v-if="$route.query.type == 2" @click="submit(1)">同意</div>
        <div class="item_btn" v-if="$route.query.type == 2" @click="submit(2)">不同意</div> -->
      </div>
    </div>
    <div class="fac_nav">
      <div class="fac_flex fac_bg">
        <img src="@/assets/img/Haier-logo.png" />
        <span class="nav_title">{{ h_i18n('515ddeee81af7132f758a3c4a18f1cef') }}</span>
        <div>
          <span style="color: #4e5969">{{ h_i18n('642ab685aba1536a43228fea4ac9e11b') }}</span>
          {{ detailQueryList.reportNo }}
        </div>
      </div>
      <div class="factory_item">
        <div class="nav_th33"><div class="nav_left_befor">{{ h_i18n('bef1852b76c31a26cf3b4e807d2adca2') }}</div><div class="nav_right">{{ detailQueryList.supplyName }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('a790803c161d5f63232969c039e9698c') }}</div><div class="nav_right">{{ detailQueryList.supplyCode }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('c8e8ee29e799350ace1a295ca32cb359') }}</div><div class="nav_right">{{ detailQueryList.supplyBacth }}</div></div>
      </div>
      <div class="factory_item">
        <div class="nav_th33"><div class="nav_left_befor">{{ h_i18n('d3d82d46881ddede6be88387fa1ecea0') }}</div><div class="nav_right">{{ detailQueryList.mtlName }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('fd5b64ec505f303e7c052ce0d5690b21') }}</div><div class="nav_right">{{ detailQueryList.mtlNo }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('b8fbaa583ff73989211624be1414623a') }}</div><div class="nav_right">{{ time(detailQueryList.bacthProductDate, 3) }}</div></div>
      </div>
      <div class="factory_item" style="margin-bottom:12px">
        <div class="nav_th33"><div class="nav_left_befor">{{ h_i18n('cc25f3610216df222b35f3f7dce22434') }}</div><div class="nav_right">{{ detailQueryList.bacthLine }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('c01c0e854c1f9f00e5f7c3d2abd92c8a') }}</div><div class="nav_right">{{ detailQueryList.shiftProduct }}</div></div>
        <div class="nav_th33"><div class="nav_left">{{ h_i18n('eacc5904f51d94762f1f31ac89359507') }}</div><div class="nav_right">{{ detailQueryList.bacthNum }}</div></div>
      </div>
    </div>
    <div class="fac_inp" style="height: auto;">
      <template v-if="!notEyeFlag && !zeroFlag">
        <div class="factory_item" v-if="notEyeFlag">
          <div class="nav_flex"><div class="nav_left_befor" style="color: #1D2129;font-weight: 600;">{{ h_i18n('91b3565dcab9afc50ada0e3914bdb04a') }}</div><div class="nav_right">{{ h_i18n('494250b365a9f7f93c4183b0c613363e') }}</div></div>
        </div>
        <div class="factory_item" v-if="!notEyeFlag">
          <div class="nav_flex"><div class="nav_left_befor" style="color: #1D2129;font-weight: 600;">
            <el-tooltip effect="redTip" placement="top">
            <span style="margin-right: 8px;">{{ h_i18n('b96626929870187c15891ac9d25e6dc8') }}<help theme="outline" size="13" style="color:#2681FF;cursor: pointer;
                      position: relative;top: 2px; line-height: 15px; height: 15px;" />
            </span>
            <template #content>
              <span>{{ h_i18n('cd38545e4f2c9cfe5b09d37f9dd91d7b') }}<br/>{{ h_i18n('96d5c39ce6bf11bce733a9d65b75b878') }}</span>
            </template>
          </el-tooltip></div><div class="nav_right"> 
            <span v-if="zeroFlag">{{ h_i18n('b13d24b2a36318f6120a1b039770b6a7') }}</span>
          <span v-else>{{ h_i18n('7c98ddedde170cc8e6431e0d3abfffa1') }}</span></div></div>
        </div>
      </template>
      <div class="factory_item" v-if="!notEyeFlag">
        <div class="nav_flex">
          <div class="nav_left_befor" style="color: #1D2129;font-weight: 600;">{{ h_i18n('5abc888751ec65a563ad1644f0109e44') }}</div>
          <div class="nav_right">{{ detailQueryList.factoryAddressNew }}</div>
        </div>
      </div>
      <div class="factory_item" v-if="notEyeFlag">
        <div class="nav_flex">
          <div class="nav_left_befor" style="color: #1D2129;">{{ h_i18n('5401ae1d4192129f5665f06b4229fcd0') }}</div>
          <div class="nav_right">{{ detailQueryList.factoryAddress }}</div>
        </div>
      </div>
      <div style="display: flex;" v-if="!notEyeFlag && !zeroFlag">
        <div style="margin-right:112px;margin-left:20px">
          <div style="color: #1D2129;text-indent: 16px;margin-bottom:10px">{{ h_i18n('23803bdb1bedf46c553c11206a75d34a') }}</div>
          <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;">
          <el-image style="width: 376px; height: 182px;margin:4px"
            :src="$filePathSplicing(detailQueryList.samplePhotoUuid, 'img')"
            :fit="contain"
            :preview-src-list="detailQueryList.samplePhotoUuid? [$filePathSplicing(detailQueryList.samplePhotoUuid, 'img')] : []">
              <template #error>
                <Picture style="width:80px;color: #ccc;padding-top: 35px;padding-bottom:35px" />
              </template>
            </el-image>
            </div>
            <div style="margin-top: 15px;">{{formDate( detailQueryList.uploadSamplePhotoTime ,6) }}</div>
        </div>
        <div>
          <div style="color: #1D2129;text-indent: 16px;margin-bottom:10px">{{ h_i18n('713f77fe004d0583a8f903afcb9ad722') }}</div>
          <div style="border:1px solid #E5E6EB;border-radius:4px;width:384px;height:190px;    text-align: center;">
          <el-image style="width: 376px; height: 182px;margin:4px"
            :src="$filePathSplicing(detailQueryList.inspectionPocessPhotoUuid, 'img')"
            :fit="contain"
            :preview-src-list="detailQueryList.inspectionPocessPhotoUuid? [$filePathSplicing(detailQueryList.inspectionPocessPhotoUuid, 'img')] : []">
              <template #error>
                <Picture style="width:80px;color: #ccc;padding-top: 35px;padding-bottom:35px" />
              </template>
            </el-image>
            </div>
            <div style="margin-top: 15px;">{{formDate( detailQueryList.uploadInspectionPocessPhotoTime ,6) }}</div>
        </div>
      </div>
    </div>
    <div class="fac_table_wrap">

   
    <div class="fac_table">
      <div class="fac_tr" style="height: 40px;background:rgb(241, 242, 248);text-align:center;line-height:40px">
        <div class="fac_table_50">{{ h_i18n('faaadc447b1c2b1adc920d9c9aedcc25') }}</div>
        <div class="fac_table_150">{{ h_i18n('222c0f1a6341c9df01ca58fc982db93b') }}</div>
        <div class="fac_table_max">{{ h_i18n('afb44627fabcf435b4633f1f6bd12eb3') }}</div>
        <div class="fac_table_100">{{ h_i18n('4626e7457839719f5fa1b08526e5e3fd') }}</div>
        <div class="fac_table_100">{{ h_i18n('0cf684d33849528278363c0e3991cb82') }}</div>
        <div class="fac_table_100">AQL</div>
        <div class="fac_table_100">{{ h_i18n('9e23b61ce24cfada6fea1cdc2277976c') }}</div>
        <div class="fac_table_100">
          <div style="width: 100%;height:50%;line-height:20px">{{ h_i18n('9ad6f829b961e347a0c8233ea1e57e42') }}</div>
          <div style="width: 100%;height:50%;display:flex;text-align:center;line-height:20px">
            <div style="width: 50%;">AC</div>
            <div style="width: 50%;">RE</div>
          </div>
        </div>
        <div class="fac_table_300">{{ h_i18n('c5fb490f9763ca6e6320049b20e23a92') }}</div>
        <div class="fac_table_100">{{ h_i18n('4158228943415a8cc85084d68ef18802') }}</div>
      </div>
      <div v-for="(item, index) in qbTableList" :key="index">
        <div class="fac_table_nav" style="display:flex;">{{ h_i18n('93857b3e7110f600d178883ce9b9bbe5') }}<span class="overflow" style="color: #165DFF;display:inline-block;width:145px;overflow:hidden;" :title="item.templateCode">{{ item.templateCode
            }}</span>{{ h_i18n('815c8383e4d0e5642f8856a49e752c73') }}<span style="color: #165DFF;margin-left:12px" :title="item.templateName">{{ item.templateName }}</span>
        </div>
        <div v-for="(child, childIndex) in item.itemList" :key="child.itemId" class="fac_tr">
          <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
          <div class="fac_table_150 fac_table_hidden fac_left overflow" :title="child.itemName" style="display:inline-block;">{{ child.itemName }}</div>
          <div class="fac_table_max fac_table_hidden" style="text-align: left" :title="child.remark">
            <span style="display: inline-block;width: 95%;" class="overflow">{{ child.remark }}</span>
          </div>
          <div class="fac_table_100">
            <el-select disabled v-if="child.importanceProperty != null" v-model="child.importanceProperty"
              :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option v-for="optionKey in importantList" :key="optionKey.valueId + ''"
                :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
            </el-select>
            <el-select disabled v-else v-model="child.importancePropertyName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option v-for="optionKey in importantList" :key="optionKey.importancePropertyName + ''"
                :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
            </el-select>
          </div>
          <div class="fac_table_100">
            <el-select disabled v-if="child.checkLevel != null" v-model="child.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
              @change="changeFun">
              <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''" :label="optionKey.valueName"
                :value="optionKey.valueId + ''"></el-option>
            </el-select>
            <el-select disabled v-else v-model="child.checkLevelName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
              <el-option :label="child.checkLevelName" :value="child.checkLevelName">
                {{ child.checkLevelName }}
              </el-option>
            </el-select>
          </div>

          <div class="fac_table_100">
            <el-input disabled v-model="child.aqlProperty" />
          </div>
          <div class="fac_table_100">
            {{ child.sampleNum }}
          </div>
          <div class="fac_table_50">
            {{ child.ac }}
          </div>
          <div class="fac_table_50">
            {{ child.re }}
          </div>
          <div class="fac_table_300 fac_table_hidden" :title="child.measured" style="text-align:center">
          {{ child.measured }}
          </div>
          <div class="fac_table_100">
            <!-- {{ child.voteResult }} -->
            <span v-if="child.voteResult == '合格'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
            <span v-if="child.voteResult == '不合格'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
            <span v-if="child.voteResult == '不适用'">{{ h_i18n('321ff794aab8c6cd671990a98ef212a0') }}</span>  
          </div>
        </div>
      </div>
      <div class="fac_table_nav" v-if="comTableList.length"><span style="color:  #165DFF;;">{{ h_i18n('09334806287d60f5b2bb2a3719f30fa8') }}</span></div>
        <div v-for="(child, childIndex) in comTableList" :key="child.itemId">
          <div class="fac_tr" v-if="!(child.itemName == '有害物质' || child.itemName == '认证情况')">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden fac_left" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div class="fac_table_100">
              <!-- {{child.importanceProperty}} -->
              <el-select disabled v-if="child.importanceProperty" v-model="child.importanceProperty" @change="changeFun"
                :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')">
                <el-option v-for="optionKey in importantList" :key="optionKey.valueId + ''"
                  :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
              <el-select disabled v-else v-model="child.importancePropertyName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
                <el-option v-for="optionKey in importantList" :key="optionKey.valueId + ''"
                  :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
            </div>
            <div class="fac_table_100">
              <!-- {{child.checkLevel}} -->
              <el-select disabled v-if="child.checkLevel" v-model="child.checkLevel" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')"
                @change="changeFun">
                <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''"
                  :label="optionKey.valueName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
              <el-select disabled v-else v-model="child.checkLevelName" :placeholder="h_i18n('708c9d6d2ad108ab2c560530810deae9')" @change="changeFun">
                <el-option v-for="optionKey in checkLevelList" :key="optionKey.valueId + ''"
                  :label="optionKey.checkLevelName" :value="optionKey.valueId + ''"></el-option>
              </el-select>
            </div>

            <div class="fac_table_100">
              <el-input :disabled="true" v-model="child.aqlProperty" />
            </div>
            <div class="fac_table_100">
              {{ child.sampleNum }}
            </div>
            <div class="fac_table_50">
              {{ child.ac }}
            </div>
            <div class="fac_table_50">
              {{ child.re }}
            </div>
            <div class="fac_table_300 fac_table_hidden" :title="child.measured" style="text-align:center">
              {{ child.measured }}
            </div>
            <div class="fac_table_100">
              <!-- {{ child.voteResult }} -->
              <span v-if="child.voteResult == '合格'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-if="child.voteResult == '不合格'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <span v-if="child.voteResult == '不适用'">{{ h_i18n('321ff794aab8c6cd671990a98ef212a0') }}</span>
            </div>
          </div>
          <div v-if="child.itemName == '认证情况'" class="fac_tr">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden fac_left" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max2 fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div style="width: 200px;text-align:left" class="fac_table_hidden" :title="detailQueryList.authName">{{ h_i18n('55a3e6968f75c5f67c9f5ed0d4e5e520') }}{{ detailQueryList.authName }}
            </div>
            <div style="width: 200px;text-align:left" class="fac_table_hidden" :title="detailQueryList.authNo">{{ h_i18n('8cec96236fcf463d33b4373495a77b1f') }}{{ detailQueryList.authNo }}
            </div>
            <div style="width: 200px;" class="fac_left">{{ h_i18n('e65e9341562a7569baf0cf88025bad3a') }}{{ time(detailQueryList.authDate, 3) || '/' }}
            </div>
            <div class="fac_table_100">
              <!-- {{ child.voteResult }} -->
              <span v-if="child.voteResult == '合格'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-if="child.voteResult == '不合格'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <span v-if="child.voteResult == '不适用'">{{ h_i18n('321ff794aab8c6cd671990a98ef212a0') }}</span>
            </div>
          </div>
          <div class="fac_tr" v-if="child.itemName == '有害物质'">
            <div class="fac_table_50 fac_center">{{ childIndex + 1 }}</div>
            <div class="fac_table_150 fac_table_hidden fac_left" :title="child.itemName">{{ child.itemName }}</div>
            <div class="fac_table_max2 fac_table_hidden" :title="child.remark">{{ child.remark }}</div>
            <div style="width: 400px;text-align:left" class="fac_table_hidden" :title="detailQueryList.rohsNo">{{ h_i18n('78bdb82bbe4f8f7ad2a9d2526f422c31') }}{{detailQueryList.rohsNo}}
            </div>
            <div style="width: 200px;" class="fac_left">{{ h_i18n('e65e9341562a7569baf0cf88025bad3a') }}{{ time(detailQueryList.rohsDate, 3) }}
            </div>
            <div class="fac_table_100">
              <!-- {{ child.voteResult }} -->
              <span v-if="child.voteResult == '合格'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-if="child.voteResult == '不合格'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
              <span v-if="child.voteResult == '不适用'">{{ h_i18n('321ff794aab8c6cd671990a98ef212a0') }}</span>
            </div>
          </div>
          
          </div>
          <div class="fac_tr">
            <div style="width: 200px;text-indent:50px;" class="fac_left" >{{ h_i18n('487bb72f29181cf97d58155646ef0b5e') }}</div>
            <div class="marginAuto" style="width:calc(100% - 900px);text-align:left" >{{ h_i18n('2e0d9892075bc5322e7a5fb62729e2de') }}{{ detailQueryList.checkEmpName }}
            </div>
            <div class="marginAuto" style="width: 200px;text-align:left" >{{ h_i18n('fe29d3d7cffb862773a2f6f43127581c') }}{{ time(detailQueryList.checkDate, 3) }}
            </div>
            <div class="marginAuto" style="width: 200px;text-align:left" >{{ h_i18n('9ea251b1d161e75872be246cf84b4c60') }}{{ detailQueryList.auditEmpName }}
            </div>
            <div style="width: 200px;" class="fac_left">{{ h_i18n('247efdcc3c5a6289eefaa1fe66d9bf8e') }}{{ time(detailQueryList.auditDate, 3) }}
            </div>
            <div class="fac_table_100">
              <!-- {{ detailQueryList.checkResult }} -->
              <span v-if="detailQueryList.checkResult === '合格'">{{ h_i18n('86f720320b77bb62311f0a4811db04fe') }}</span>
              <span v-if="detailQueryList.checkResult === '不合格'">{{ h_i18n('6e5a122013138ad189517d5d0a1c0891') }}</span>
            </div>
          </div>
          <div class="fac_tr" style="height: auto;line-height:24px">
            <div style="width: 200px;text-indent:50px;display:flex;align-items:center" class="fac_left">{{ h_i18n('97d7e7ac40b2a31b9cdbde20c724114b') }}</div>
            <div style="width:calc(100% - 210px);text-align:left">
              <p style="text-align: left;text-indent: 4ch;white-space: normal;">{{ h_i18n('c09e45e5b92cd767be3c844cdbd5006b') }}</p>
              <el-checkbox style="text-align: center;width: 100%;" v-model="haseRead" disabled label="1">{{ h_i18n('ee1dfef67afe79135693b84b74f6185e') }}</el-checkbox>
            </div>
          </div>
          <div class="fac_inp" style="height:130px">
            <div class="fac_inp_title">审核意见</div>
            <el-input type="textarea" style="margin-top: 20px;" disabled v-model="audittextarea">
            </el-input>
          </div>
      </div>
  </div>
  </div>

</template>










<script>
//Automatic script writing.
import h_i18n from '@/utils/Internationalization';

import { Picture } from '@element-plus/icons'
export default {
  name: 'TemplateDetailHmqmTemplate',
  components: { Picture },
  data() {
    return {
      audittextarea:'',
      detailQueryList: {},//基本数据
      tableList: [],
      importantList: [],
      checkLevelList: [],
      templateCardLength: 0,
      addVisible: false,
      dialogTableList: [],
      templateCode: '',
      templateItem: '',
      auditOpinion: '',//审核意见
      detailQueryList: [],
      qbTableList: [],
      comTableList: [],
      notEyeFlag: true, // 无天眼
      zeroFlag: true, // 30天无不合格，取消照片关联
      haseRead:true,
    }
  },
  methods: {
    h_i18n,
    getEyeQuery() {
      // console.log('查询deleteStatus')
      this.$http({
        url: '/base/visualeye/listPage',
        method: 'post',
        data: {
          pageNo: 1,
          pageSize: 10,
          supplyCode: this.$route.query.supplyCode,
          name: this.$route.query.name,
          nickName: this.$route.query.nickName
        }
      }).then((res) => {
        console.log(res, '天眼列表信息')
        if (res.data.code != "200" || res.data.data.records.length == 0) {
          this.notEyeFlag = true // 无天眼
        } else {
          this.notEyeFlag = false // 有天眼
        }
        let screenDeleteStatus
        if (res.data.data.records.length && res.data.data.records[0].deleteStatus) {
          screenDeleteStatus = res.data.data.records[0].deleteStatus
        }
        console.log(screenDeleteStatus, '天眼状态字段N 必须截图；Y不能截图')
        if (screenDeleteStatus == 'N') { // deleteStatus = N 必须截图
          // this.needFactoryMonitorFlag = true
          this.zeroFlag = false

        } else if (screenDeleteStatus == 'Y') {
          this.zeroFlag = true
        } else {
          this.zeroFlag = false
        }

      })
    },
    //时间截取
    formDate(val, len = 3) {
      if (val) {
        return this.time(val, len)
      } else {
        return ""
      }
    },
    submit(v) {
      if (!this.auditOpinion) {
        this.info(h_i18n('e08e608c9408e404b78b9baa03d0adf9'))
        return
      }
      this.$http({
        method: "post",
        url: '/base/baseShipmentTemplate/audit',
        data: {
          "shipmentId": this.detailQueryList.shipmentId,
          "status": v === 1 ? "Y" : "N",
          "auditOpinion": this.auditOpinion,
          "name": this.$route.query.name,
          "nickName": this.$route.query.nickName
        }
      }).then(res => {
        console.log(res, '审核提交')
        if (res.data.success) {
          this.success(h_i18n('23b62e9cbc868e024b80d2e3fad80ac7'))
          this.$router.back()
        } else {
          this.error(res.data.msg)
        }
      })
    },
    synchronizeData() {
      this.$router.push({
        name: "FactoryTemplateSqmTemplateHistory",
        query: {
          name: this.$route.query.name,
          nickName: this.$route.query.nickName,
          mtlNo: this.detailQueryList.mtlNo,
          dataFrom: this.$route.query.dataFrom,
          supplyCode: this.$route.query.supplyCode,
        },
      });
    },
    addTemplateCard() {
      this.addVisible = true
    },
    //数据查询
    getQueryList() {
      this.$http({
        url: '/base/baseShipmentReport/reportsItem?reportId=' + this.$route.query.reportId,
        method: "get",
      }).then((res) => {
        console.log(res, '详细数据列表')
        this.closeLoading()
        if (res.data.success) {
          this.detailQueryList = res.data.data
          this.qbTableList = res.data.data.itemList
          this.comTableList = res.data.data.commonList
          this.audittextarea = res.data.data.auditOpinion;
          if (res.data.data.samplePhotoUuid) {//抽样样品图片
            this.detailQueryList.samplePhotoUuid = res.data.data.samplePhotoUuid
          }
          if (res.data.data.inspectionPocessPhotoUuid) {//检验过程图片
            this.detailQueryList.inspectionPocessPhotoUuid = res.data.data.inspectionPocessPhotoUuid
          }

        } else {
          this.info(res.data.msg)
        }
      })
    },
    inspectionUpdate() {
      this.postThisPageHeight()
    },
    arraySpanMethod(data) {
      if (data.row.frontKey === "OTHER" || data.row.frontKey === "OTHERT") {

        return { rowspan: 1, colspan: 8 }
      }
    },
    searchByValueTypeId(id) {
      this.$http({
        method: "get",
        url: '/base/basicData/listBaseValues?valueTypeId=' + id,
      }).then(res => {
        console.log(res.data.data, id, '14检查水平，13重要性')
        if (id == 13) {
          this.importantList = res.data.data
        }
        if (id == 14) {
          this.checkLevelList = res.data.data
          console.log(this.checkLevelList)
        }
      })
    },

  },
  created() {

  },
  mounted() {
    this.startLoading(h_i18n('26b5bd4947df8be257c59dde927b400c'))
    this.searchByValueTypeId(13)
    this.searchByValueTypeId(14)
    this.getQueryList();
    this.getEyeQuery()//天眼
    setTimeout(() => {
      this.inspectionUpdate()
    }, 1000);
  },
}
</script>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
.el-input__inner{
    color: #1D2129 !important;
}
.haier-td {
    color: #1D2129 !important;
}
.el-textarea__inner{
  color: #1D2129 !important;
}
.haier-table {
  border: none !important;
}

.factory_item {
  font-size: 14px;
  display: flex;
  width: 100%;
  background-color: #fff;
  line-height: 40px;
  height: 40px;

  .nav_th33 {
    display: flex;
    width: 33%;
  }

  .nav_left {
    width: 120px;
    color: #4E5969;
    text-align: left;
  }

  .nav_left_befor {
    color: #4E5969;
    margin-left: 16px;
  }

  .nav_right {
    color: #1D2129;
    text-align: left;
    text-indent: 12px;
  }

  .nav_flex {
    display: flex;
  }
}

.haier-table-header--content {
  height: 56px !important;

  .haier-table-header--left {
    font-size: 24px !important;
    color: #1D2129;
    font-weight: normal !important;
  }
}

.haier-table-header--logo {
  width: 90px !important;
  height: 34px !important;
  margin-left: 17px;

  img {
    width: 90px !important;
  }
}

.temtable {
  width: 100%;
  min-height: 300px;
  // overflow-y: auto;
  border-top: 1px solid #ccc;

  .table_item {
    .item_nav {
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;
      border-bottom: 1px solid #ccc;
      height: 46px;
      line-height: 46px;
      // background-color: #f8f8f8;
    }
  }

  .center {
    text-align: center;
  }

  .table_flex {
    display: flex;
    height: 46px;
    line-height: 46px;
    border-left: 1px solid #ccc;
    border-bottom: 1px solid #ccc;

    .center {
      text-align: center;
    }

    .table_50 {
      width: 50px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
    }

    .table_100 {
      width: 100px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
    }

    .table_150 {
      width: 150px;
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 90% !important;
        margin-left: 5% !important;
      }
    }

    .biaozun {
      width: calc(100% - 608px);
      height: 100%;
      border-right: 1px solid #ccc;

      .el-input__inner {
        width: 98% !important;
        margin-left: 1% !important;
      }
    }
  }

}

.template_dialog {
  .dialog_search {
    height: 40px;
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    margin-left: 5%;

    .dialog_input {
      width: 200px !important;
      margin: 0 20px !important;
    }
  }

  .dialog_center {
    .cen_nav {
      width: 90%;
      height: 40px;
      display: flex;
      align-items: center;
      text-align: center;
      margin-left: 5%;
      background-color: #ddedfe;

      div {
        width: 50%;
        height: 100%;
        border: 1px solid #ccc;
        line-height: 40px;

      }
    }

    .dialog_table {
      width: 90%;
      margin-left: 5%;
      border-bottom: 1px solid #ccc;
      max-height: 330px;
      overflow-y: auto;
      margin-bottom: 20px;

      .nodata {
        height: 100px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-left: 1px solid #ccc;
        border-right: 1px solid #ccc;
      }

      .item {
        height: 30px;
        line-height: 30px;
        border: 1px solid #ccc;
        border-bottom: none;
        cursor: pointer;
        display: flex;
        text-indent: 20px;

        .item_code {
          width: 50%;
        }

        .item_name {
          width: 50%;
          overflow: hidden;
          white-space: nowrap;
          text-overflow: ellipsis;
        }
      }

      .item:hover {
        background-color: #ddedfe;
      }
    }

    .nomes {
      margin-left: 5%;
    }
  }

  .dialog_footer {
    margin-left: 5%;
  }
}

body {
  overflow: auto !important
}

.haier-inspection-header .haier-table .haier-table-header .haier-table-header--right {
  // width: 0 !important;
  width: calc((100% / 6) * 2 - 1px) !important;
}

.el-textarea__inner {
  //height: 90px !important;
}

.haier-td {
  border-right: 1px solid #ccc;
  border-bottom: 1px solid #ccc;
  text-align: left;
  padding: 4px 10px;
  font-size: 14px;
  height: 35px;
  color: #666;
}

.is-right {
  text-align: right;
}

table {
  width: 100%;
  border-top: 1px solid #ccc;
  border-left: 1px solid #ccc;

  thead {
    color: #000;
    // font-weight: bold;
  }

  tbody {
    font-size: 14px;
    // tr:nth-child(odd){
    //   background: #ecf5ff;
    // }
    .title {
      background: #F8F8F8;
      line-height: 30px;
      text-align: left;
      text-indent: 20px;

      &>span {
        padding-right: 20px;
        padding-left: 10px;
        color: #3a8ee6;
      }

      &>div {
        float: right;
        padding-right: 20px;
      }

      .el-button {
        min-height: 20px;
        padding: 3px 15px;
      }
    }

    .desc {
      text-align: left;
      text-indent: 20px;
    }
  }

  td {
     border-bottom: 1px solid #ccc;
     border-right: 1px solid #ccc;
    text-align: center;

    i {
      cursor: pointer;
      padding-right: 10px;
    }
  }

}
</style>

<style src="@/assets/css/new.scss" lang="scss"></style>

<style lang="scss">
.config-provide {
  background: #f2f4f7 !important;
  margin: 0 !important;
}

html,
body {
  overflow-y: auto !important;
  // // width: 95%;
  // overflow-x: hidden;
}
.h-upload-template-upload {
  display: none !important;
}
.shipmentReport {
  width: 100%;
  background: #f2f4f7;
  font-size: 14px;
  margin-bottom: 48px;
  min-width: 1200px;
  .fac_flex {
    display: flex;
  }
  .fac_line {
    line-height: 40px;
  }
  .tabbar {
    width: 100%;
    height: 46px;
    background: #fff;
    margin-bottom: 8px;
    line-height: 46px;
    // position: fixed;
    // top: 0;
    // z-index: 9999;
    border-bottom: 1px solid #f2f4f7;
    // margin-top: 72px;
    .add_title {
      font-weight: 400;
      color: #1d2129;
      font-size: 16px;
      margin-right: 16px;
      float: left;
    }

    .add_import_title {
      color: #86909c;
      font-size: 14px;
      float: left;
    }

    .btn_gro {
      float: right;
      display: flex;
      margin-right: 16px;
      margin-top: 6px;

      .item_btn {
        width: 80px;
        height: 32px;
        line-height: 32px;
        text-align: center;
        font-size: 14px;
        color: #1d2129;
        border-radius: 8px;
        margin-left: 12px;
        border: 1px solid #E5E6EB;
        cursor: pointer;
      }
    }
  }
  .factory_item {
    font-size: 14px;
    display: flex;
    width: 100%;
    background-color: #fff;
    line-height: 40px;
    height: 40px;
  
    .nav_th33 {
      display: flex;
      width: 33%;
    }
  
    .nav_left {
      min-width: 120px;
      width: auto;
      color: #4E5969;
      text-align: left;
    }
  
    .nav_left_befor {
      color: #4E5969;
      margin-left: 16px;
    }
  
    .nav_right {
      color: #1D2129;
      text-align: left;
      text-indent: 12px;
    }
  
    .nav_flex {
      display: flex;
    }
  }
  .fac_nav {
    padding: 16px 16px 8px 16px;
    background-color: #fff;
    margin: 0 16px 12px 16px;
    border-radius: 8px;
    margin-top: 16px;

    .fac_bg {
      justify-content: space-between;
      background-color: #f1f2f8;
      border-radius: 8px;
      height: 56px;
      padding: 0 16px;
      line-height: 56px;
      font-size: 14px;
      color: #1d2129;
      align-items: center;

      .nav_title {
        font-size: 24px;
      }

      img {
        width: 91px;
        height: 34px;
      }
    }

    .fac_mes {
      height: 40px;
      line-height: 40px;
      justify-content: space-between;
    }
  }

  .fac_inp {
    padding: 16px;
    margin: 0 16px 12px 16px;
    background-color: #fff;
    border-radius: 8px;

    .fac_inp_title {
      color: #1d2129;
      font-weight: 600;
    }

    .fac_33 {
      width: 33%;
      line-height: 34px;
    }
  }

  .fac_photo {
    padding: 16px;
    height: auto;
    margin: 0 16px 12px 16px;
    background-color: #fff;
    border-radius: 8px;
  }
  .fac_table_wrap{
    padding: 16px;
    margin: 0 16px;
    background-color: #fff;
    border-radius: 8px;
  }
  .fac_table {
    height: auto;
    // margin: 0 16px 12px 16px;
    background-color: #fff;
    border-radius: 8px;
    border: 1px solid #E5E6EB;
    .el-input__inner {
      width: 90% !important;
    }

    .fac_table_nav {
      height: 44px;
      font-size: 14px;
      text-align: left;
      line-height: 44px;
      border-bottom: 1px solid #E5E6EB;
      padding: 0 16px;
    }

    .fac_tr {
      display: flex;
      // height: 44px;
      font-size: 14px;
      text-align: center;
      // line-height: 44px;
      min-height: 44px;
      line-height: 22px;
      border-bottom: 1px solid #E5E6EB;
      padding: 0 16px;
    }

    .fac_table_50 {
      width: 50px;
      margin: auto;
    }

    .fac_table_100 {
      width: 100px;
      margin: auto;
    }

    .fac_table_150 {
      width: 150px;
      margin: auto;
    }

    .fac_table_max {
      width: calc(100% - 900px);
      margin: auto;
    }
    .fac_table_300 {
      width: 300px;
      margin: auto;
      padding: 5px;
      word-wrap: break-word;
    }
    .fac_table_max {
      width: calc(100% - 1100px);
      margin: auto;
      text-align: left;
      padding: 5px;
      min-width: 200px;
    }
    .fac_table_max2 {
      width: calc(100% - 900px);
      margin: auto;
      text-align: left;
      padding: 5px;
      
    }
    .fac_center {
      text-align: center;
    }
    .fac_left {
      text-align: left;
      margin: auto;
    }

    .fac_table_hidden {
      // overflow: hidden;
      // text-overflow: ellipsis;
      // white-space: nowrap;
      margin: auto;
    }
    .marginAuto{
      margin: auto;
    }
  }
  .overflow{
    overflow:hidden;
    word-break:break-all;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>